<template>
  <section class="spaces-container" v-if="isLoading" style="margin-top: 10px;">
    <v-progress-circular indeterminate color="#2877BC" :size="30" :width="4"></v-progress-circular>
  </section>
  <section class="spaces-container" v-else>
    <div class="c-sort lg:flex md:flex sm:block block items-center w-100">
      <div class="lg:mb-[0px] md:mb-[0px] sm:mb-[15px] mb-[15px] w-100" v-if="props.titleName">
        <h2 class="text-[14px] font-bold">{{ props.titleName }}の貸し会議室・レンタルスペース・イベント会場を一覧から探す</h2>
      </div>
      <SortSpace @handleSort="emitHandleSort" :totalSpace="totalSpace" />
    </div>
    <div v-if="totalSpace && !isLoading" class="space-list">
      <template v-for="(spaceItem, index) in spaceList" :key="spaceItem.id || index">
        <SpaceItem :isSortByGroup="true" :isArea="props.isArea" :spaceInfo="spaceItem" :no="index" :selectedDate="props.researchValue.date" v-if="spaceItem"
          :pageCurrent="pageCurrent" />
      </template>
      <section class="spaces-container" v-if="isLoadingSpace || spaceList.length < total">
        <v-progress-circular indeterminate color="#2877BC" :size="30" :width="4"></v-progress-circular>
      </section>
    </div>
    <div v-else-if="totalSpace == 0 && !isLoading && isFirstLoadingDone" class="no-data-search">
      <li>検索結果がありません</li>
      <li>エリアやカテゴリー、人数の条件を変えてみることで</li>
      <li>
        条件に合った貸し会議室・レンタルスペースが表示されるかもしれません。
      </li>
    </div>
  </section>
</template>

<script setup>
/* eslint-disable */
import { ref, watch, onMounted, defineProps, defineEmits, onUnmounted } from "vue";
import SpaceItem from "@/client/components/Space/SpaceItem.vue";
import { getListSpaceByLocationApi } from "@/client/api";

import moment from "moment";
import { RENTAL_SPACE_STATUS } from "@/client/const";
import { getDateTime } from "@/client/const/search";

import SortSpace from "@/client/components/SortSpace/SortSpace.vue";
import { isEqual, toNumber } from "lodash";
import { useRoute, useRouter } from "vue-router";

const router = useRouter();
const route = useRoute();
moment.locale("ja");
const spaceList = ref([]);
const totalSpace = ref(0);
const pageCurrent = ref(1);
const sortValue = ref(route?.query?.ss ?? "");
const isLoading = ref(true);
const prevDataSearch = ref(null);
const isFirstLoadingDone = ref(false);
const isLoadingSpace = ref(false)
const total = ref(0)

const emit = defineEmits(['emitTotalSpace','isFirstLoadingDone']);

const props = defineProps({
  researchValue: {
    type: Object,
    default: () => {
      return {
        ga: "",
        lp: "",
        ctg: "",
        pp: "",
        dt: "",
        ss: "",
        ar: "",
      };
    },
  },
  isSort: {
    type: Boolean,
  },
  isArea: {},
  valueSort: {
    type: String,
  },
  isLoading: {
    type: Boolean,
  },
  titleName : {
    type: String,
  }
});

const listPeopleFormTo = [
  { id: "1-5", data: { from: 1, to: 5 } },
  { id: "6-20", data: { from: 6, to: 20 } },
  { id: "21-40", data: { from: 21, to: 40 } },
  { id: "41-60", data: { from: 41, to: 60 } },
  { id: "61-100", data: { from: 61, to: 100 } },
  { id: "101-", data: { case_person: 101 } },
];

const getSearchPeople = () => {
  if (route.query.pp) {
    const result = listPeopleFormTo.filter((item) => {
      return route.query.pp == item.id;
    });
    if (result.length) {
      return result[0].data;
    }
  }
  return {};
};
const scrollTop = () => {
  window.scrollTo(0, 0);
};

// Add or update the <meta name="robots"> tag directly
const updateRobotsMeta = (content) => {
    let robotsTag = document.querySelector('meta[name="robots"]');
    robotsTag.setAttribute('content', content);
 }
    
const initData = async (filter) => {
  isLoading.value = true;
  if (filter) {
    const [selectedDate, timeStart, timeEnd] = getDateTime(filter?.dt);
    let dataSearch = {
      lp: filter.lp,
      selectedDate: selectedDate,
      timeStart: timeStart,
      timeEnd: timeEnd,
      ts_category_spaces_id: filter.ctg,
      people_count: getSearchPeople(),
      status: RENTAL_SPACE_STATUS.published,
      fe: "vn",
      page: filter.page ?? pageCurrent.value,
      item_per_page: 10,
      search_sort: filter.ss,
      group_area: toNumber(filter.ga) || '',
      area_id: filter.ar,
    };

    if (!isEqual(dataSearch, prevDataSearch.value)) {
      prevDataSearch.value = dataSearch
      spaceList.value = []
      const SpacesRes = await getListSpaceByLocationApi(dataSearch);
      spaceList.value = SpacesRes.data?.data;
      total.value = SpacesRes.data?.total;
      totalSpace.value = SpacesRes.data?.total;
      isFirstLoadingDone.value = true;
      emit('isFirstLoadingDone', true);
       
      if (SpacesRes.data?.total === 0 || dataSearch.area_id?.split(',')?.length > 1 || dataSearch.ts_category_spaces_id?.split(',')?.length > 1 || route.query.utm_source) {
        updateRobotsMeta('noindex');
      } else {
        updateRobotsMeta('');
      }
  
      if(!handleSortRunning) {
        isLoading.value = false;
      }
    }
  } else {
    if(!handleSortRunning) {
      isLoading.value = false;
    }
  }

}

onMounted(() => {
  scrollTop();
});

watch(props?.researchValue, async (newValue, oldValue) => {
  if (props?.researchValue) {
    pageCurrent.value = 1
    setTimeout(async () => {
      if(route.params.area_slug && !newValue.ga) {
        return
      }
      await initData({ ...newValue, page: 1 });
      if(!handleSortRunning) {
          isLoading.value = false;
      }
    }, 500);
  }
}, {
  deep: true,
  immediate: true,
}
);

watch(route, () => {
  if (route?.query?.ss) {
    sortValue.value = route?.query?.ss
  }
})

let handleSortRunning = false;
const handleSort = async (val) => {
  try {
    isLoading.value = true;
    handleSortRunning = true;

    const selectSortValue = val;
    sortValue.value = val;

    const [selectedDate, timeStart, timeEnd] = getDateTime(props.researchValue?.dt);
    const dataSearch = {
      lp: props.researchValue.lp,
      selectedDate: selectedDate,
      timeStart: timeStart,
      timeEnd: timeEnd,
      ts_category_spaces_id: props.researchValue.ctg,
      people_count: getSearchPeople(),
      status: RENTAL_SPACE_STATUS.published,
      fe: "vn",
      page: 1,
      item_per_page: 10,
      search_sort: val,
      group_area: toNumber(props.researchValue.ga) || '',
      area_id: props.researchValue.ar || '',
    };

    let urlSearch = {
      lp: dataSearch.lp,
      dt: props.researchValue.dt,
      ctg: dataSearch.ts_category_spaces_id,
      pp: props.researchValue.pp,
      ss: selectSortValue,
      ga: dataSearch.group_area,
      ar: dataSearch.area_id,
    }
    if (props.isSort) {
      router.push({
        query: cleanQueryParams(urlSearch),
      });
    } else {
      router.push({
        query: cleanQueryParams(urlSearch),
      });
    }

    pageCurrent.value = 1;

    if (!isEqual(dataSearch, prevDataSearch.value)) {
      prevDataSearch.value = dataSearch
      const SpacesRes = await getListSpaceByLocationApi(dataSearch);
      spaceList.value = SpacesRes.data.data;
      totalSpace.value = SpacesRes?.data?.total || 0;
      handleSortRunning = false;
      
      if (SpacesRes.data?.total === 0 || dataSearch.area_id?.split(',')?.length > 1 || dataSearch.ts_category_spaces_id?.split(',')?.length > 1 || route.query.utm_source) {
        updateRobotsMeta('noindex');
      } else {
        updateRobotsMeta('');
      }
    }
  } catch (errors) {
    spaceList.value = [];
    handleSortRunning = false;
  } finally {
    isLoading.value = false;
    handleSortRunning = false;
  }
};

const cleanQueryParams = (formResearch) => {
  const cleanQuery = Object.entries(formResearch).reduce((acc, [key, value]) => {
    if (value !== "" && value !== undefined && value !== null) {
      acc[key] = value;
    }
    return acc;
  }, {});

  return cleanQuery;
};

const emitHandleSort = (data, valSort) => {
  if (data) {
    handleSort(valSort);
  }
};

const loadSpace = async () => {
  if (isFirstLoadingDone.value) {
    try {
      isLoadingSpace.value = true
      const [selectedDate, timeStart, timeEnd] = getDateTime(props.researchValue?.dt);
      let dataSearch = {
        lp: props.researchValue.lp,
        selectedDate: selectedDate,
        timeStart: timeStart,
        timeEnd: timeEnd,
        ts_category_spaces_id: props.researchValue.ctg,
        people_count: getSearchPeople(),
        status: RENTAL_SPACE_STATUS.published,
        fe: "vn",
        page: pageCurrent.value + 1,
        item_per_page: 10,
        search_sort: sortValue.value,
        group_area: toNumber(props.researchValue.ga) || '',
        area_id: props.researchValue.ar || '',
      };

      if (!isEqual(dataSearch, prevDataSearch.value)) {
        prevDataSearch.value = dataSearch
        const SpacesRes = await getListSpaceByLocationApi(dataSearch);
        spaceList.value.push(...SpacesRes.data.data);
        totalSpace.value = SpacesRes?.data?.total || 0;
        if (SpacesRes.data.data && SpacesRes.data.data?.length) {
          pageCurrent.value = pageCurrent.value + 1;
        }
        
        if (SpacesRes.data?.total === 0 || dataSearch.area_id?.split(',')?.length > 1 || dataSearch.ts_category_spaces_id?.split(',')?.length > 1 || route.query.utm_source) {
            updateRobotsMeta('noindex');
        } else {
            updateRobotsMeta('');
        }
      
      }
    } catch (errors) {
      console.log(errors);
    } finally {
      isLoadingSpace.value = false
    }
  }
}

const emitScroll = () => {
  emit('emitTotalSpace', totalSpace.value);
}

const scrollLoadSpace = async () => {
  const scrollTop = window.pageYOffset;
  const allElements = document.querySelectorAll('.space-item-container')
  if (allElements.length > 0 && spaceList.value.length < total.value) {
    const lastVisibleElement = allElements[allElements.length - 3];
    const offsetTopLastElement = lastVisibleElement.offsetTop
    if (scrollTop >= offsetTopLastElement && isLoadingSpace.value === false) {
      await loadSpace()
    }
  } else {
    isLoadingSpace.value = false
  }
}

onMounted(() => {
  window.addEventListener("scroll", emitScroll);
  window.addEventListener("scroll", scrollLoadSpace)
});

onUnmounted(() => {
  window.addEventListener("scroll", emitScroll);
  window.addEventListener("scroll", scrollLoadSpace)
});

</script>

<style scoped lang="scss">
@import "./SearchSpaces.scss";
</style>
